document.querySelectorAll('.accordion-toggle').forEach(function (accordion) {
    accordion.addEventListener('click', function (event) {
        event.preventDefault();
        const headerText = this.querySelector('.accordion-header h3').textContent.trim();
        _paq.push(['trackEvent', 'Accordion opened/closed', 'Click', headerText]);
    });
});